import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import { orderStatus } from '../../../../../utils/constant';
import MultiSelect from './multiSelect';

const FilterByStatus = ({ filters, setFilters, includeIncompleteStatus }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByStatus, statusFiltersIot }
  } = localizedStrings;
  const { incomplete } = orderStatus;

  let statusList = statusFiltersIot;

  if (!includeIncompleteStatus)
    statusList = statusList.filter(item => item.value !== incomplete);

  return (
    <div>
      <MultiSelect
        label={filterByStatus}
        options={statusList.map(item => ({
          label: item.text,
          value: item.value
        }))}
        value={filters.status}
        updateFilters={value => {
          setFilters({ ...filters, status: value });
        }}
      />
    </div>
  );
};

FilterByStatus.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired,
  includeIncompleteStatus: PropTypes.bool.isRequired
};

export default FilterByStatus;
